import { Component, OnInit } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';

@Component({
  selector: 'app-seo',
  templateUrl: './seo.component.html',
  styleUrls: ['./seo.component.scss']
})
export class SeoComponent implements OnInit {
  constructor(private seoService: SeoService) { }

  query = 'امیر';
  limit = 10;
  links: { Url: string, Text: string }[];
  result: { [key: string]: number }[];

  async ngOnInit() {
  }

  async find() {
    delete this.result;
    delete this.links;

    this.links = await this.seoService.find(this.query, this.limit);
  }

  async analyse() {
    delete this.result;
    delete this.links;

    this.result = await this.seoService.analyse(this.query, this.limit);
  }
}
